import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/logo.webp";
import { useCart } from "../context/CartContext";
import CartModal from "./CartModal";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCartModalOpen, setIsCartModalOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { cartItems } = useCart();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);
  const toggleCartModal = () => setIsCartModalOpen(!isCartModalOpen);

  const cartItemCount = cartItems.reduce(
    (total, item) => total + item.quantity,
    0
  );

  return (
    <>
      <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
        <NavLink to="/" onClick={closeMenu}>
          <img src={logo} alt="lkofoods-logo" className="navbar-logo" />
        </NavLink>

        <div className="mobile-order-now">
          <NavLink
            to="/order-online"
            className="order-now-btn post-review-btn"
            onClick={closeMenu}
          >
            Order Now
          </NavLink>
        </div>

        <div className="navbar-toggle" onClick={toggleMenu}>
          <i className={`fas ${isMenuOpen ? "fa-times" : "fa-bars"}`}></i>
        </div>

        <ul className={`navbar-links ${isMenuOpen ? "open" : ""}`}>
          <li>
            <NavLink
              to="/"
              end
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? "selected" : "")}
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/buffet"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? "selected" : "")}
            >
              Buffet
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/private-events"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? "selected" : "")}
            >
              Event Halls
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/book-table"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? "selected" : "")}
            >
              Book Table
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? "selected" : "")}
            >
              Contact
            </NavLink>
          </li>
          <li>
            <a
              href="https://lasgidirestaurant.com/blog"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
            >
              Blog
            </a>
          </li>
          <li>
            <NavLink
              to="/order-online"
              onClick={closeMenu}
              className="order-now-btn post-review-btn"
            >
              Order Now
            </NavLink>
          </li>
        </ul>

        <div className="navbar-cart">
          <NavLink to="#" onClick={toggleCartModal}>
            <i className="fas fa-shopping-cart cart-btn navbar-cart-btn"></i>
            <span className="cart-counter1">{cartItemCount}</span>
          </NavLink>
        </div>
      </nav>

      <CartModal
        isOpen={isCartModalOpen}
        cartItems={cartItems}
        onClose={() => setIsCartModalOpen(false)}
      />

      <div className="floating-cart cart-container">
        <NavLink to="#" onClick={toggleCartModal}>
          <i className="fas fa-shopping-cart cart-btn navbar-cart-btn"></i>
          <span className="cart-counter2">{cartItemCount}</span>
        </NavLink>
      </div>
    </>
  );
}

export default Navbar;
